import React, { useState } from "react";
import { Copy } from "lucide-react";
import { CurrencyRow } from "./../../Components/CurrencyCard/EmptyCard";
import { useOverview } from "./../../hooks";

const AddFundsDrawer = () => {
  const { currencies, useGlobalAccount } = useOverview();
  const firstGroup = currencies?.slice(0, 3);
  const secondGroup = currencies?.slice(3, 6);

  const { data: globalData } = useGlobalAccount();

  const beneficiaryDetails = [
    {
      label: "Beneficiary Name",
      value:
        [
          globalData?.data?.user?.firstName,
          globalData?.data?.user?.middleName,
          globalData?.data?.user?.lastName,
        ]
          .filter(Boolean)
          .join(" ") || "",
      key: "A",
    },
    {
      label: "Beneficiary Account Number",
      value: globalData?.data?.vendorAccountNo,
      key: "B",
    },
    { label: "Bank Code", value: globalData?.data?.bankCode, key: "C" },
    { label: "Branch Code", value: globalData?.data?.branchCode, key: "D" },
    { label: "SWIFT Code", value: globalData?.data?.vendorSwiftCode, key: "E" },
    {
      label: "Beneficiary Bank Name",
      value: globalData?.data?.vendorBankName,
      key: "F",
    },
    {
      label: "Beneficiary Bank Address",
      value:
        globalData?.data?.vendorAddress &&
        globalData?.data?.vendorCity &&
        globalData?.data?.vendorCountry
          ? globalData?.data?.vendorAddress +
            " " +
            globalData?.data?.vendorCity +
            ", " +
            globalData?.data?.vendorCountry+
            ", " +
              "018982"
          : " ",
      key: "G",
    },
    {
      label: "Beneficiary Bank Phone Number",
      value: "+65 1800 111 1111",
      key: "H",
    },
  ];
  const [copiedKey, setCopiedKey] = useState(null);

  const handleCopy = (value, key) => {
    if (value) {
      navigator.clipboard.writeText(value);
      setCopiedKey(key);
      setTimeout(() => setCopiedKey(null), 2000);
    }
  };

  return (
    <div className="w-full  bg-white h-full">
      {/* <div className="p-4 border-b">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <button className="p-2 hover:bg-gray-100 rounded-full">
              <ArrowLeft size={20} />
            </button>
            <div>
              <h2 className="text-lg font-semibold">Add Funds</h2>
              <p className="text-sm text-gray-500">To multi-currency account</p>
            </div>
          </div>
          <button className="p-2 hover:bg-gray-100 rounded-full">
            <X size={20} />
          </button>
        </div>
      </div> */}

      <div className="py-4">
        <div className="rounded-md bg-[#F7F7F8] px-[24px] py-[24px]">
          <div className="">
            <h3 className="font-geomanistBold text-[14px] leading-[20px] font-[400] mb-1">
              How to fund your account?
            </h3>
            <p className="text-[14px] leading-[20px] text-greyish font-[400] font-geomanistRegular">
              Transfer funds to your multi-currency account via SWIFT transfer
              using your beneficiary details given below
            </p>
          </div>

          <div className="pt-[14px]">
            <h3 className="font-geomanistBold text-[14px] leading-[20px] font-[400] mb-1">
              Accepted currencies
            </h3>
            <p className="text-[14px] leading-[20px] text-greyish font-[400] font-geomanistRegular">
              Funds sent will be reflected in the corresponding currency
              balance.
            </p>

            <div className="flex flex-col mt-[15px] gap-[13px]">
              <CurrencyRow items={firstGroup} shadow={false} hover={false} />
              <CurrencyRow items={secondGroup} shadow={false} hover={false} />
            </div>
          </div>
        </div>

        <h3 className="font-geomanistBold text-[14px] leading-[20px] font-[400] mt-4 mb-1">
          Your unique beneficiary details
        </h3>
        <p className="text-[14px] leading-[20px] text-greyish font-[400] font-geomanistRegular mb-[16px]">
          Funds need to be wired to this account.
        </p>

        <div className="rounded-md bg-[#F7F7F8] ">
          {beneficiaryDetails.map((detail, index) => (
            <div
              key={detail.key}
              // ${detail.key === "B" && "bg-[#FFF2EB]"}
              className={`  p-[16px] ${
                index !== beneficiaryDetails.length - 1 && "border-b"
              }`}
            >
              <div className="flex items-center gap-2 mb-2">
                <div className="w-6 h-6 rounded-full bg-black flex items-center justify-center text-[12px] font-[500] leading-[16px] text-white font-geomanistMedium">
                  {detail.key}
                </div>
                <label className="text-sm font-geomanistBold font-[400] leading-[20px] text-blackShade">
                  {detail.label}
                </label>
              </div>
              <div className="flex">
                <input
                  type="text"
                  value={detail.value}
                  readOnly
                  className="ml-8 font-geomanistBold focus:outline-none text-[14px] leading-[20px] pl-4 flex-1 p-2 border rounded-md bg-white "
                />
                <button
                  className="px-5 text-blackShade hover:text-blue-800 flex items-center gap-2 hover:cursor-pointer"
                  onClick={() => handleCopy(detail.value || "", detail.key)}
                >
                  <Copy
                    size={20}
                    className={`${
                      copiedKey === detail.key ? "text-green-500" : ""
                    }`}
                  />
                  {copiedKey === detail.key && (
                    <span className="text-sm text-green-500 animate-pulse">
                      Copied!
                    </span>
                  )}
                </button>
              </div>
              {/* {detail.key === "B" && (
                <p className=" ml-8 text-sm  text-[#FA5B05] mt-2">
                  Everyone has a unique beneficiary account number
                </p>
              )} */}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AddFundsDrawer;
